<template>
  <div class="doc">
    <header class="bar">
      <router-link class="back" to="/admin/guides">All guides</router-link>
      <nav>
        <router-link to="/admin/guides/admin">Admin</router-link>
        <router-link to="/admin/guides/student">Student</router-link>
      </nav>
    </header>
    <iframe :src="src" :title="title" class="frame" />
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const FILES = {
  admin: { src: '/guides/admin-user-guide.html', title: 'Admin guide' },
  student: { src: '/guides/student-user-guide.html', title: 'Student guide' },
}

const route = useRoute()
const router = useRouter()
const entry = computed(() => FILES[route.params.doc])
const src = computed(() => entry.value?.src || '')
const title = computed(() => entry.value?.title || 'Guide')

watch(
  () => route.params.doc,
  (doc) => {
    if (!FILES[doc]) router.replace({ name: 'admin-guides' })
  },
  { immediate: true },
)
</script>

<style scoped>
.doc {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - var(--nav-height) - 3rem);
}

.bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.bar a {
  color: var(--teal);
  text-decoration: none;
  font-weight: 600;
}

.bar a.router-link-active:not(.back) {
  text-decoration: underline;
  text-underline-offset: 4px;
}

nav {
  display: flex;
  gap: 1rem;
}

.frame {
  flex: 1;
  width: 100%;
  min-height: 70vh;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--cream);
}
</style>
